import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { testimonials } from "../lib/data";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % testimonials.length), 6000);
    return () => clearInterval(t);
  }, []);

  const t = testimonials[idx];

  return (
    <section className="relative py-28 px-6 lg:px-8 bg-[#070B1A] overflow-hidden">
      <div className="orb bg-blue-700" style={{ width: 500, height: 500, top: "10%", left: "-10%" }} />

      <div className="max-w-5xl mx-auto relative">
        <div className="text-center mb-12">
          <span className="section-label">Testimonials</span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
            Loved by <span className="gradient-text">investors</span> across India
          </h2>
        </div>

        <div className="relative glass-strong rounded-3xl p-8 md:p-12">
          <Quote className="absolute top-6 right-6 w-16 h-16 text-blue-500/15" />
          <AnimatePresence mode="wait">
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.4 }}
              className="grid md:grid-cols-3 gap-8 items-center"
              data-testid={`testimonial-${idx}`}
            >
              <div className="md:col-span-1">
                <div className="relative">
                  <img src={t.img} alt={t.name} className="w-40 h-40 rounded-2xl object-cover" />
                  <div className="absolute -bottom-3 -right-3 px-3 py-1.5 rounded-xl bg-blue-600 text-xs font-bold flex items-center gap-1">
                    <Star className="w-3 h-3 fill-white" />
                    {t.rating}.0
                  </div>
                </div>
              </div>
              <div className="md:col-span-2">
                <div className="flex gap-1 mb-4">
                  {[...Array(t.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>
                <p className="text-xl text-slate-100 leading-relaxed font-medium italic">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="mt-6">
                  <div className="font-bold text-lg">{t.name}</div>
                  <div className="text-sm text-slate-400">{t.role}</div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center justify-between mt-8 pt-6 border-t border-white/10">
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIdx(i)}
                  data-testid={`testimonial-dot-${i}`}
                  className={`h-2 rounded-full transition-all ${
                    i === idx ? "w-8 bg-blue-500" : "w-2 bg-white/20"
                  }`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length)}
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-white/10"
                data-testid="testimonial-prev"
              >
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button
                onClick={() => setIdx((i) => (i + 1) % testimonials.length)}
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:bg-white/10"
                data-testid="testimonial-next"
              >
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
